export default function setSBAAuthenticationCookie(token?: string) {
  if (token) {
    // set cookie
    document.cookie = `sba_auth_data=${token};path=/`;
  } else {
    // delete cookie
    document.cookie = `sba_auth_data=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
}
